import { render, staticRenderFns } from "./chapterDialog.vue?vue&type=template&id=6216bdce&scoped=true&"
import script from "./chapterDialog.vue?vue&type=script&lang=js&"
export * from "./chapterDialog.vue?vue&type=script&lang=js&"
import style0 from "./chapterDialog.vue?vue&type=style&index=0&id=6216bdce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216bdce",
  null
  
)

export default component.exports